// Map colors to particle textures
const colorToTexture = {
  // Fireball colors (as strings from JSON)
  '0xff6600': 'particle-red',    // Orange
  '0xff4400': 'particle-red',    // Dark orange
  '0xff2200': 'particle-red',    // Red

  // Fire Blast colors (as strings from JSON)
  '0xff3300': 'particle-red',    // Dark red
  '0xff1100': 'particle-red',    // Very dark red

  // Lightning colors (as strings from JSON)
  '0x4444ff': 'particle-grey',   // Dark blue
  '0x0088ff': 'particle-white',  // Light blue
  '0x00ffff': 'particle-white',  // Cyan

  // Default fallback
  default: 'particle-white'
};

export function createParticles(scene, x, y, config) {
  // Debug: log the color we're receiving
  console.log('Particle color received:', config.color, typeof config.color);

  // Choose texture based on color
  const textureKey = colorToTexture[config.color] || colorToTexture.default;

  // Debug: log which texture was selected
  console.log('Selected texture:', textureKey, 'for color:', config.color);

  // Set up initial configuration based on config type
  let particleConfig = {
    speed: config.speed || 100,
    scale: config.scale || 0.05,
    alpha: config.alpha || 1,
    lifespan: config.duration || 1000,
    quantity: 1
    // Remove tint since we're using colored textures now
  };

  // Special handling for trail effects
  if (config.trail) {
    particleConfig.frequency = 50;
    particleConfig.speed = config.speed || 100;
  } else {
    particleConfig.frequency = config.frequency || 10;
  }

  const emitter = scene.add.particles(x, y, textureKey, particleConfig);

  // Add spin effect if requested
  if (config.spin) {
    // For spinning effects, we'll create multiple emitters with rotation
    // This is a simplified approach - in a full implementation you'd use custom particle classes
    setTimeout(() => {
      if (emitter && !emitter.destroyed) {
        // Add some rotation to existing particles (simplified spin effect)
        emitter.setAngle({ min: 0, max: 360 });
      }
    }, 100);
  }

  // Add smoke trail if requested
  if (config.smokeTrail) {
    // Create a separate smoke emitter that follows
    const smokeEmitter = scene.add.particles(x, y, 'particle-grey', {
      speed: (config.speed || 100) * 0.3, // Slower smoke
      scale: 0.2,
      alpha: { start: 0.6, end: 0.0 },
      lifespan: 1500,
      quantity: 1,
      frequency: 30
    });
    return { main: emitter, smoke: smokeEmitter };
  }

  // Configure based on particle type
  if (config.shape === 'rectangle') {
    // For lightning-style effects
    emitter.setTexture('shield-grey'); // Use a rectangular texture if available
  }


  if (config.beam) {
    // Instant beam effect
    emitter.explode(config.count || 20);
    return { main: emitter };
  }

  if (config.branches) {
    // Create branching lightning effect
    const branchTexture = colorToTexture[config.color] || colorToTexture.default;
    for (let i = 0; i < config.branches; i++) {
      const angle = (i / config.branches) * Math.PI * 2;
      const branchEmitter = scene.add.particles(x, y, branchTexture, {
        speed: { min: 200, max: 400 },
        angle: { min: angle * 180 / Math.PI - 30, max: angle * 180 / Math.PI + 30 },
        scale: config.scale || 0.3,
        alpha: config.alpha || 1,
        lifespan: config.duration || 800,
        quantity: 3
        // No tint since we're using colored textures
      });
      branchEmitter.explode(config.count || 8);
    }
    return { main: emitter };
  }

  // Handle smoke explosion for hit effects
  if (config.smoke) {
    // Create additional smoke particles for explosion
    const smokeEmitter = scene.add.particles(x, y, 'particle-grey', {
      speed: { min: 50, max: 150 },
      scale: { start: 0.5, end: 2.0 },
      alpha: { start: 0.7, end: 0.0 },
      lifespan: config.duration || 2000,
      quantity: 2,
      frequency: 20
    });
    smokeEmitter.explode(config.count || 15);
    emitter.explode(config.count || 15);
    return { main: emitter, smoke: smokeEmitter };
  }

  // Default explosion effect
  if (config.count) {
    emitter.explode(config.count);
  } else {
    emitter.start();
  }

  return { main: emitter };
}